export default "__VITE_ASSET__ff1c056a__"